import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { AudioPlayerModule, MotesGeolocation, MotesGeolocationStub, MotesLoginModule, MotesSdkModule, MOTES_DISPLAY_LOCALE_ID, SimpleModalModule, SvgIconModule, VideoPlayerModule } from '@motes-sdk';
import { ToastModule } from '@motes-sdk/components/toast/toast.module';
import { CookieModule } from '@motes-sdk/cookie/cookie.module';

// Environment and debugging
import { environment } from '@env/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { MapOverlayComponent } from './components/map-overlay/map-overlay.component';

// Danish locale: still used where templates pass `da-DK` to the `date` pipe explicitly.
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import { ErrorHandlerService } from './services/error-handler.service';
registerLocaleData(localeDa);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        HeaderComponent,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SvgIconModule,
        MotesSdkModule.forRoot(environment.firebase),
        MotesLoginModule.forRoot(),
        NgxWebstorageModule.forRoot(),
        VideoPlayerModule,
        AudioPlayerModule,
        ToastModule,
        SimpleModalModule,
        MapOverlayComponent,
        CookieModule
    ],
    providers: [
        Location,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: LOCALE_ID, useValue: MOTES_DISPLAY_LOCALE_ID },
        { provide: MotesGeolocation, useClass: MotesGeolocationStub },
        { provide: ErrorHandler, useClass: ErrorHandlerService },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
